import { useCallback } from "react";
import { getClientDomain, getToken } from "../utils/Common";

export const useCash = () => {

    // const getCashBoxStatus = useCallback(async (signal) => {
    //     const response = await fetch(`${getClientDomain()}/cashbox/status`, {
    //         method: 'GET',
    //         headers: {
    //             'Content-Type': 'application/json',
    //             'authorization': `Bearer ${getToken()}`
    //         },
    //         signal: signal
    //     });


    // const result = await response.json();
    // if (result?.payload?.length > 0) return {...result, payload: result.payload[0]};
    // else return [];
    // }, []);

    const getCashBoxStatus = useCallback(async (signal) => {
        const response = await fetch(`${getClientDomain()}/cashbox/status`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });
    
        const result = await response.json();

        if (Array.isArray(result?.payload) && result.payload.length > 0) {
            return result?.payload;
        } else if (result?.payload) {
            return { ...result?.payload };
        } else {
            return { ...result, payload: [] };
        }
    }, []);

    const openCloseCash = useCallback(async (signal, data) => {
        
        const response = await fetch(`${getClientDomain()}/cashbox/openClose`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`,
            },
            body: JSON.stringify(data),
            signal: signal
        });


    const result = await response.json();
    if (result?.payload?.length > 0) return {...result, payload: result.payload[0]};
    else return {...result};
    }, []);

    const getCashBoxMovements = useCallback(async (signal, type) => {
        const response = await fetch(`${getClientDomain()}/cashbox/movements`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify({ type : type.join(",") }),
            signal: signal
        });

        const result = await response.json();
        
        if (Array.isArray(result?.payload) && result.payload.length > 0) {
            return result;
        } else if (result?.payload) {
            return { ...result, payload: [result.payload] };
        } else {
            return { ...result, payload: [] };
        }
    }, []);

    const addRemoveCashBox = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain()}/cashbox/addRemove`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`,
            },
            body: JSON.stringify(data),
            signal: signal
        });

        const result = await response.json();

        if (result?.payload?.length > 0) return {...result, payload: result.payload[0]};
        else return {...result};
    }, []);

    const getAllCashBoxMovements = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain()}/cashbox/allMovements`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(data),
            signal: signal
        });

        const result = await response.json();

        if (Array.isArray(result?.payload) && result.payload.length > 0) {
            return result;
        } else if (result?.payload) {
            return { ...result, payload: [result.payload] };
        } else {
            return { ...result, payload: [] };
        }
    }, []);

    const createCashBox = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain()}/cashbox/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(data),
            signal: signal
        });

        const result = await response.json();

        if (result?.payload?.length > 0) return {...result, payload: result.payload[0]};
        else return {...result};
    }
    , []);

    const updateCashBox = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain()}/cashbox/update`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(data),
            signal: signal
        });

        const result = await response.json();

        if (result?.payload?.length > 0) return {...result, payload: result.payload[0]};
        else return {...result};
    }
    , []);

    const getCashBoxesList = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain()}/cashbox/list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(data),
            signal: signal
        });

        const result = await response.json();

        if (Array.isArray(result?.payload) && result.payload.length > 0) {
            return result?.payload;
        } else if (result?.payload) {
            return { ...result, payload: [result.payload] };
        } else {
            return { ...result, payload: [] };
        }
    }
    , []);

    const manageCashBoxes = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain()}/cashbox/manage`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(data),
            signal: signal
        });

        const result = await response.json();

        if (result?.payload?.length > 0) return {...result, payload: result.payload[0]};
        else return {...result};
    }
    , []);

    const getDailyMovements = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain()}/cashbox/dailyMovements`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(data),
            signal: signal
        });

        const result = await response.json();

        if (Array.isArray(result?.payload) && result.payload.length > 0) {
            return result;
        } else if (result?.payload) {
            return { ...result, payload: [result.payload] };
        } else {
            return { ...result, payload: [] };
        }
    }, []);

    const createDailyReport = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain()}/cashbox/createDR`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(data),
            signal: signal
        });

        const result = await response.json();

        if (result?.payload?.length > 0) return { ...result, payload: result.payload[0] };
        else return { ...result };
    }, []);

    const searchDailyReport = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain()}/cashbox/searchDR`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(data),
            signal: signal
        });

        const result = await response.json();

        if (Array.isArray(result?.payload) && result.payload.length > 0) {
            return result;
        } else if (result?.payload) {
            return { ...result, payload: [result.payload] };
        } else {
            return { ...result, payload: [] };
        }
    }, []);

    return { getCashBoxStatus, openCloseCash, getCashBoxMovements,
         addRemoveCashBox, getAllCashBoxMovements,
          createCashBox, updateCashBox, getCashBoxesList, manageCashBoxes, getDailyMovements, createDailyReport 
        , searchDailyReport
        };
}